// Angular
import { Injectable } from '@angular/core';
import { MatSnackBar, MatDialog } from '@angular/material';
// Partials for CRUD
import { ActionNotificationComponent,
	DeleteEntityDialogComponent,
	FetchEntityDialogComponent,
	UpdateStatusDialogComponent,
	

} from '../../../../views/partials/content/crud';

import {SaveStatusDialogComponent} from '../../../../../../src/app/views/partials/content/crud/Save-Status-Dialog/save-status-dialog.component';
import { SaveTicketDialogComponent } from '../../../../../../src/app/views/partials/content/crud/SaveTicket/save-ticket-dialog.component';
import { ContinueEntityDialogComponent } from '../../../../../../src/app/views/partials/content/crud/Continue-entity-dialog/continue-entity-dialog.component';
import { CommonEntityDialogComponent } from '../../../../views/partials/content/crud/Common-dialog-Entity/common-entity-dialog.component';
import { InfoEntityDialogComponent } from '../../../../views/partials/content/crud/Info-entity-dialog/info-entity-dialog.component';

export enum MessageType {
	Create,
	Read,
	Update,
	Delete
}

@Injectable()
export class LayoutUtilsService {
  editCustomer(_title: string, _description: string, _waitDesciption: string) {
    throw new Error('Method not implemented.');
  }
  CustomerEditDialogComponent(_title: string, _description: string, _waitDesciption: string) {
    throw new Error('Method not implemented.');
  }
	/**
	 * Service constructor
	 *
	 * @param snackBar: MatSnackBar
	 * @param dialog: MatDialog
	 */
	constructor(private snackBar: MatSnackBar,
		           private dialog: MatDialog) { }

	/**
	 * Showing (Mat-Snackbar) Notification
	 *
	 * @param message: string
	 * @param type: MessageType
	 * @param duration: number
	 * @param showCloseButton: boolean
	 * @param showUndoButton: boolean
	 * @param undoButtonDuration: number
	 * @param verticalPosition: 'top' | 'bottom' = 'top'
	 */
	showActionNotification(
		_message: string,
		_type: MessageType = MessageType.Create,
		_duration: number = 1000,
		_showCloseButton: boolean = true,
		_showUndoButton: boolean = true,
		_undoButtonDuration: number = 3000,
		_verticalPosition: 'top' | 'bottom' = 'bottom'
	) {
		const _data = {
			message: _message,
			snackBar: this.snackBar,
			showCloseButton: _showCloseButton,
			showUndoButton: _showUndoButton,
			undoButtonDuration: _undoButtonDuration,
			verticalPosition: _verticalPosition,
			type: _type,
			action: 'Undo'
		};
		return this.snackBar.openFromComponent(ActionNotificationComponent, {
			duration: _duration,
			data: _data,
			verticalPosition: _verticalPosition,
			panelClass: ['red-snackbar']
		});
	}

	/**
	 * Showing Confirmation (Mat-Dialog) before Entity Removing
	 *
	 * @param title: stirng
	 * @param description: stirng
	 * @param waitDesciption: string
	 */
	deleteElement(title: string = '', description: string = '', waitDesciption: string = '') {
		return this.dialog.open(DeleteEntityDialogComponent, {
			data: { title, description, waitDesciption },
			width: '440px'
		});
	}

	SaveElement(title: string = '', description: string = '', waitDesciption: string = '') {
		return this.dialog.open(SaveStatusDialogComponent, {
			data: { title, description, waitDesciption },
			width: '440px'
		});
	}

	/**
	 * Showing Fetching Window(Mat-Dialog)
	 *
	 * @param _data: any
	 */
	fetchElements(_data) {
		return this.dialog.open(FetchEntityDialogComponent, {
			data: _data,
			width: '400px'
		});
	}

	/**
	 * Showing Update Status for Entites Window
	 *
	 * @param title: string
	 * @param statuses: string[]
	 * @param messages: string[]
	 */
	updateStatusForEntities(title, statuses, messages) {
		return this.dialog.open(UpdateStatusDialogComponent, {
			data: { title, statuses, messages },
			width: '480px'
		});
		
	}
	SaveForTicket(title, statuses, messages) {
		return this.dialog.open(SaveTicketDialogComponent, {
			data: { title, statuses, messages },
			width: '480px'
		});}
	showContentLineByLine(content: string, duration: number = 10000) {
		const snackBarRef = this.snackBar.open(content, 'Close', { duration, verticalPosition: 'bottom', panelClass: 'multiline-snackbar' });
	}
	Continue(title: string = '', description: string = '', waitDesciption: string = '') {
		return this.dialog.open(ContinueEntityDialogComponent, {
			data: { title, description, waitDesciption },
			width: '440px'
		});
	}

		Commondialog(title: string = '', description: string = '', waitDesciption: string = '',Button1: string = '',Button2: string = '') {
		return this.dialog.open(CommonEntityDialogComponent, {
			data: { title, description, waitDesciption,Button1,Button2},
			width: '440px'
		});
	}

	/**
	 * Showing an informational message (Mat-Dialog, centered, single OK button)
	 * in place of the bottom/top snackbar from showActionNotification().
	 *
	 * @param description: string
	 * @param title: string
	 */
	showInfoMessage(description: string = '', title: string = 'Information') {
		return this.dialog.open(InfoEntityDialogComponent, {
			data: { title, description },
			width: '440px'
		});
	}
}
